import React from 'react';
import PropTypes from 'prop-types';

import './style.scss';
import { iconForTheServiceType } from 'utils/miscUtil';

function AssignmentType({
  status = 'available',
  serviceName = 'Telefontolkning',
  className = '',
  isColoredIcon = true,
  showShortText = false,
  assignment = {
    IsSpecialAssignment: false,
    OrderHasSRHR: false,
    SRHRIsRequired: false,
  },
  displayAdditionalInfo = false,
}) {
  return (
    <div className={`tv-assignment-type__container ${className}`}>
      <i
        className={` icon tv-assignment-type-article-icon material-icons ${
          isColoredIcon
            ? `tv-assignment-type-article-icon-color--${status}`
            : ''
        } `}
      >
        {iconForTheServiceType(assignment)}
      </i>
      <div className="tv-assignment-type-article-name">
        {!showShortText ? serviceName : serviceName}
      </div>
      {assignment.IsSpecialAssignment ? (
        <div className="tv-assignment-type-article-name ml-1">
          (specialuppdrag)
        </div>
      ) : null}
      {displayAdditionalInfo && (
        <>
          {assignment.OrderHasSRHR === true &&
            assignment.SRHRIsRequired === false && (
              <div className="tv-assignment-type-article-name ml-1 tv-assignment-type-article-name-additional-name">
                (Kund önskat SRHR-tolk)
              </div>
            )}
          {assignment.OrderHasSRHR === true &&
            assignment.SRHRIsRequired === true && (
              <div className="tv-assignment-type-article-name ml-1 tv-assignment-type-article-name-additional-name">
                (Kund kravställt SRHR-tolk)
              </div>
            )}
        </>
      )}
    </div>
  );
}
AssignmentType.propTypes = {
  status: PropTypes.string,
  serviceName: PropTypes.string,
  className: PropTypes.string,
  isColoredIcon: PropTypes.bool,
  showShortText: PropTypes.bool,
  assignment: PropTypes.shape({
    IsSpecialAssignment: PropTypes.bool,
    OrderHasSRHR: PropTypes.bool,
    SRHRIsRequired: PropTypes.bool,
  }),
  displayAdditionalInfo: PropTypes.bool,
};

export default AssignmentType;
